const toISOStringWithTimezone = (date: Date | any, dateType: string) => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? '+' : '-';
  const pad = (n: number) => `${Math.floor(Math.abs(n))}`.padStart(2, '0');

  const dateComponent = `${date.getFullYear()}-${pad(
    date.getMonth() + 1,
  )}-${pad(date.getDate())}`;

  const timeComponent = `${dateType === 'start' ? '00' : '23'}:${
    dateType === 'start' ? '00' : '59'
  }:${dateType === 'start' ? '00' : '59'}`;

  const offSetComponent = `${pad(tzOffset / 60)}:${pad(tzOffset % 60)}`;

  return `${dateComponent}T${timeComponent}${diff}${offSetComponent}`;
};

export default toISOStringWithTimezone;
